<div>
  <form [formGroup]="form">
    <app-searchable-select
      formFieldClass="mat-input-without-padding w-full"
      [label]="'mailAccounts' | translate"
      [items]="mailAccountOptions"
      [requireSelection]="true"
      formControlName="mailAccount" />
  </form>
</div>
